import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../components/Toaster";
import { errorSideEffects, loadingSideEffects, successSideEffects, updatingSideEffects } from "../";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../services/analytics/tracking";

export interface PrivacyPolicySchema {
  IsEnabled?: boolean;
  Mode?: string;
  PrivacyPolicies?: PrivacyPolicyVersion[];
}

export interface PrivacyPolicyVersion {
  Version: string;
  StartDateTime: string;
}

export interface PrivacyPolicyState {
  Data: PrivacyPolicySchema;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const PrvacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getPrivacyPolicy(state) {
      Object.assign(state, loadingSideEffects);
    },
    getPrivacyPolicySuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getPrivacyPolicyError(state, action) {
      Object.assign(state, errorSideEffects);
      state.errorMessage = action.payload;
    },
    updatePrivacyPolicy(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updatePrivacyPolicySuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "Privacy policy updated successfully");
    },
    updatePrivacyPolicyError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const { getPrivacyPolicy, getPrivacyPolicyError, getPrivacyPolicySuccess, updatePrivacyPolicy, updatePrivacyPolicyError, updatePrivacyPolicySuccess } = PrvacyPolicySlice.actions;

export default PrvacyPolicySlice.reducer;
